<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container">
      <asideCom :activityIndex="7"></asideCom>
      <div class="my-content">
        <div class="top-choose">
          <div class="message choose">{{$t('global.我的点赞')}}</div>
        </div>
        <div class="order">
          <div :class="{sort:contentIndex===0}"
              @click="getMyLike(0,1)">
            <span class="orderby-icon-time" :class="{'active-time':contentIndex==0}"></span>{{$t('global.最新创作')}}
          </div>
          <div :class="{sort:contentIndex===1}"
              @click="getMyLike(1,1)">
            <span class="orderby-icon-visit" :class="{'active-visit':contentIndex==1}"></span>{{$t('global.按浏览量')}}
          </div>
          <div :class="{sort:contentIndex===2}"
              @click="getMyLike(2,1)">
            <span class="orderby-icon-zan" :class="{'active-zan':contentIndex==2}"></span>{{$t('global.按点赞数')}}
          </div>
          <div :class="{sort:contentIndex===3}"
              @click="getMyLike(3,1)">
            <span class="orderby-icon-comment" :class="{'active-comment':contentIndex==3}"></span>{{$t('global.按评论数')}}
          </div>
        </div>
        <div class="play-record-content" v-if="listLength > 0">
          <div class="item"
               v-for="(item,index) in list"
               :key="index">
            <div class="item-img"
                 @click="gotoVideo(item.videoId)"
                 :style="item.thumb | bgImageUrl('',283,167)"></div>
            <div class="content">
              <div class="top" style="-webkit-box-orient: vertical;">{{item.title}}</div>
              <!--<div class="center">{{item.industryTitle}}-{{item.professionTitle}}</div>-->
              <div class="bottom">
                <div class="bottom-name"><img :src="item.avatar | imageUrl('/static/profile_img_default.png',40,40)"
                       @click="gotoHomePage(item.userId)"> {{item.nickname}}</div>
                <div class="operate-wrap">
                  <div class="delete-one"
                       @click="cancleMyLike(item.videoId,index)">
                    <img src="/static/manageCenter/delete.png"
                         class="deleteIMG">{{$t('global.取消点赞')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <content-empty v-else-if="listLength == 0" :content="$t('global.没有点赞记录')"></content-empty>
        <pages :page-size="pagerParam.pageSize"
               :page-count="pagerParam.pageCount"
               :current-page="pagerParam.currentPage"
               :total="pagerParam.total"
               @current-page-changed="OnCurrentPageChanged"></pages>
      </div>
    </div>
    <service></service>
  </main-layout>

</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout"
import service from '@/components/service.vue'
import asideCom from '@/components/aside.vue'
import pages from '@/components/pages.vue'
import ContentEmpty from '@/components/ContentEmpty.vue'
export default {
  name: 'MyLike',
  metaInfo() {
    return {
      title: this.$t("global.我的点赞") + " | MANA"
    };
  },
  data() {
    return {
      contentIndex: 0,
      list: [],
      listLength: -1,
      pagerParam: {
        pageSize: 20,
        pageCount: 1,
        currentPage: 1,
        total: 1
      }
    }
  },
  components: {
    MainLayout,
    service,
    asideCom,
    pages,
    ContentEmpty
  },
  created() {
    this.getMyLike(0)
  },
  methods: {
    getMyLike(index, pageI) {
      if (pageI) {
        this.pagerParam.currentPage = 1;
      }
      this.contentIndex = index
      let order = ''
      switch (index) {
        case 0:
          order = 'createTime'
          break
        case 1:
          order = 'viewCount'
          break
        case 2:
          order = 'likeCount'
          break
        case 3:
          order = 'commentCount'
          break
      }
      this.$http
        .get('/api/u/relation/likeList', {
          params: {
            orderBy: order,
            pageIndex: pageI || this.pagerParam.currentPage,
            pageSize:this.pagerParam.pageSize
          }
        })
        .then(response => {
          let data = response.data
          this.list = data.list
          this.pagerParam.pageSize = data.pageSize
          this.pagerParam.total = data.totalRecord
          this.pagerParam.pageCount = data.totalPage
          this.pagerParam.currentPage = data.pageIndex
          this.listLength = this.list.length
        })
    },
    cancleMyLike(videoId, index) {
      this.$http.post('/api/u/relation/cancel/like/' + videoId).then(response => {
        if (this.list.length <= 0) {
          this.pagerParam.currentPage = this.pagerParam.currentPage - 1;
        }
        this.getMyLike(0, 1);
      })
    },
    gotoVideo(videoId) {
      this.$router.push('/Video/detail?id=' + videoId)
    },
    gotoHomePage(userId) {
      this.$router.push('/peopleCenter/' + userId)
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val
      this.getMyLike(this.contentIndex)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.order
  display flex
  /* width 16rem */
  overflow hidden
  margin 0 auto
  color #777777
  line-height .17rem
  .sort
    color #0060ff
    font-weight bold
  >div
    margin 0.5rem 0 0 0.3rem
    cursor pointer
    &:first-child
      margin .5rem 0 0 0
  img
    width 0.16rem
    margin-top -0.04rem
  span
    display inline-block
    margin-left 0.1rem
.play-record-head
  display flex
  justify-content space-between
  font-size 0.2rem
  margin 0.5rem 0 0.2rem
  .delete
    color #0060ff
.my-content
  width 790px
  background-color #ffffff
  padding 40px
  border-radius 0.08rem
  .top-choose
    display flex
    justify-content center
    font-size 0.26rem
    color #707070
    span
      display block
      margin 0 0.65rem
    .choose
      color #333333
      font-weight bold
.play-record-content
  min-width 837px
  display flex
  flex-wrap wrap
  .item
    width 248px
    margin 20px 20px 0 0
    background #ffffff
    box-shadow 0 2px 4px 0 rgba(0, 0, 0, 0.1)
    border 1px solid #d5d5d5
    border-radius 0.08rem
    &:nth-child(3n)
      margin-right 0
  .item-img
    /* width 3.56rem */
    cursor pointer
    position relative
    height 2.02rem
    border-top-left-radius 0.08rem
    border-top-right-radius 0.08rem
    background url('/static/peopleCenter/item.png') no-repeat
    background-size 100%
  .content
    padding 0 0.2rem
    color #333333
    .top
      font-size 0.22rem
      font-weight bold
      margin-top 0.16rem
      height 0.6rem
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      -webkit-line-clamp:2;
    .center
      color #777777
      margin-top 0.06rem
      font-size 0.14rem
    .bottom
      display flex
      border-top 1px solid #F4F4F4
      justify-content space-between
      line-height 0.55rem
      margin-top 0.2rem
      .bottom-name
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        width: 137px;
        img
          border-radius 50%
          width 0.32rem
          height 0.32rem
      .operate-wrap
        font-size 0.16rem
        line-height 0.55rem
        display flex
        img
          margin -0.02rem 0.06rem 0 0
        .delete-one
          margin-left 0.1rem
          cursor pointer
        .editIMG
          width 0.16rem
          height 0.16rem
        .deleteIMG
          width 0.13rem
          height 0.13rem
      .error
        color #ff0000
.container
  margin 40px auto
  display flex
.orderby-icon-time{
  display: inline-block;
  width:0.16rem;
  height:0.18rem;
  background: url("/static/explore/time.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right:0.1rem;
}
.orderby-icon-visit{
  display: inline-block;
  width:0.19rem;
  height:0.18rem;
  background: url("/static/explore/visit.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right:0.1rem;
  margin-left:0.35rem;
}
.orderby-icon-zan{
  display: inline-block;
  width:0.16rem;
  height:0.18rem;
  background: url("/static/explore/zan.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right:0.1rem;
  margin-left:0.35rem;
}
.orderby-icon-comment{
  display: inline-block;
  width:0.16rem;
  height:0.18rem;
  background: url("/static/explore/comment.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right:0.1rem;
  margin-left:0.35rem;
}
.order .active-time {
  background: url("/static/explore/focusTime.png") no-repeat center center;
  background-size: contain;
}
.order .active-visit {
  background: url("/static/explore/focusVisit.png") no-repeat center center;
  background-size: contain;
}
.order .active-zan {
  background: url("/static/explore/focusZan.png") no-repeat center center;
  background-size: contain;
}
.order .active-comment {
  background: url("/static/explore/focusComment.png") no-repeat center center;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/Like.vue